const INITIAL_STATE = {
  data: {},
  errors: {},
  
}
const getPulseMKeys = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_PULSEM_KEYS_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'GET_PULSEM_KEYS_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
  
export default getPulseMKeys;